import React from "react";
import { bool, shape } from "prop-types";
import { useSelector, connect } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import { statusTagColor } from "util/echecks";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import AcceptReturnSummaryBody from "./components/Summary";
import InfoTag from "../components/InfoTag";
import { selectors as sessionSelectors } from "reducers/session";

const AcceptReturnRejectedSummaryPage = ({ isDesktop, activeEnvironment, user }) => {
    const { echeqsToDoActions, echeckTicket } = useSelector((state) => state.echecks);
    const willCancel = echeqsToDoActions?.cancelTransaction;

    const documentType = echeqsToDoActions?.echeq?.beneficiario_documento_tipo;
    const documentNumber = echeqsToDoActions?.echeq?.beneficiario_documento;
    const echeq = echeqsToDoActions?.echeq;

    const data = {
        idEcheq: echeqsToDoActions?.echeq?.cheque_id,
        fechaPago: echeqsToDoActions?.echeq?.fecha_pago,
        curency: echeqsToDoActions?.echeq?.emisor_moneda,
        numeroEcheq: echeqsToDoActions?.echeq?.cheque_numero,
        montoTotal: echeqsToDoActions?.echeq?.monto,
        caracter: echeqsToDoActions?.echeq?.cheque_caracter,
        nombreSolicitante: user?.userFullName,
        cuilSolicitante: activeEnvironment?.activeUserCuil,
        // los campos de abajo se usan en el activity
        tenenciaBeneficiarioDocumento: echeqsToDoActions?.echeq?.tenencia_beneficiario_documento,
        tenenciaBeneficiarioDocumentoTipo: echeqsToDoActions?.echeq?.tenencia_beneficiario_documento_tipo,
        tenenciaBeneficiarioNombre: echeqsToDoActions?.echeq?.tenencia_beneficiario_nombre,
        // los campos de abajo no se muestra en la pantalla de confirmacion
        document: `${documentType} ${documentNumber}`,
        documentNumber: echeqsToDoActions?.echeq?.beneficiario_documento,
        documentType: echeqsToDoActions?.echeq?.beneficiario_documento_tipo,
        fechaEmision: echeqsToDoActions?.echeq?.fecha_emision,
        action: echeqsToDoActions?.action,
        echeqList: [echeqsToDoActions?.echeq],
        echeqsToDoActions,
        idTransaction: echeqsToDoActions?.idTransaction,
        estado: echeqsToDoActions?.echeq?.estado,
        endosos: echeqsToDoActions?.echeq?.endosos,
    };

    const State = () => (
        <InfoTag type="info" message={echeq?.estado} tagBackground={statusTagColor(echeq?.estado)} tagClass="ml-5" />
    );

    useConfirmTransaction(data, echeckTicket, "echecks/rejected/return/accept");

    return (
        <>
            <Notification scopeToShow="AcceptReturnRejected" />
            <ResponsiveHeader id="echeq.accept.return" defaultTitle="Aceptar Acuerdo" infoComponents={<State />} />

            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id={willCancel ? "cancel.title" : "echeq.cac.summary"} />
                    </h2>
                    <div className="container--alert" role="alert">
                        <div className="alert alert-info">
                            <CustomData
                                icon="information_fill.svg"
                                titleText={i18n.get("echeq.accept.return.disclaimer")}
                                titleTextType="TEXT"
                                keepSpaceIfNoValue={false}
                            />
                        </div>
                    </div>
                    <AcceptReturnSummaryBody
                        idEcheq={echeqsToDoActions?.echeq?.cheque_id}
                        fechaPago={echeqsToDoActions?.echeq?.fecha_pago}
                        curency={echeqsToDoActions?.echeq?.emisor_moneda}
                        numeroEcheq={echeqsToDoActions?.echeq?.cheque_numero}
                        montoTotal={echeqsToDoActions?.echeq?.monto}
                        caracter={echeqsToDoActions?.echeq?.cheque_caracter}
                        nombreSolicitante={data?.nombreSolicitante}
                        cuilSolicitante={data?.cuilSolicitante}
                        endosos={data?.endosos}
                        isDesktop={isDesktop}
                    />
                    <GeneralCredentialForm
                        hideIndications
                        transactionData={data}
                        action={willCancel ? echeckActions.cancelTransfer : echeckActions.acceptReturnRejected}
                        isCancel={willCancel}
                        idActivity="accept.return.rejected.echeq"
                        disableContinueIfEmpty
                    />
                </div>
            </MainContainer>
        </>
    );
};

AcceptReturnRejectedSummaryPage.propTypes = {
    isDesktop: bool.isRequired,
    user: shape({}),
    activeEnvironment: shape({}),
};

const mapStateToProps = (state) => ({
    user: sessionSelectors.getUser(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(AcceptReturnRejectedSummaryPage);
